import React from "react";
import Form from "./Form";
import bgImg from "../../../assets/home/hero_sec_img.webp";
import feature1 from "../../../assets/home/feature-1.webp";
import feature2 from "../../../assets/home/feature-2.webp";
import feature3 from "../../../assets/home/feature-3.webp";
import icon1 from "../../../assets/home/icon1.png";
import icon2 from "../../../assets/home/icon2.png";
import icon3 from "../../../assets/home/icon3.png";
import icon4 from "../../../assets/home/icon4.png";
import icon5 from "../../../assets/home/icon5.png";
import icon6 from "../../../assets/home/icon6.png";
import iconBg from "../../../assets/home/backgroundimg.webp";

const featureData = [
  {
    title: "Need a Ride?",
    alt: "Traveller booking an outstation cab on the Pulpit app",
    image: feature1,
    icon: icon1,
  },
  {
    title: "Confirm & Relax",
    alt: "Confirmed Pulpit cab booking with driver details on screen",
    image: feature2,
    icon: icon2,
  },
  {
    title: "Ride & Reach Safely",
    alt: "Passenger arriving safely by Pulpit intercity taxi",
    image: feature3,
    icon: icon3,
  },
];

const Main = ({ routePrefill, heading, subheading }) => {
  return (
    <main className="home-main">
      <section className="home-hero-bg">
        <div className="home-hero-container">

          {/* Image + icons — icons anchor to image only */}
          <div className="home-hero-image">
            <img
              src={bgImg}
              alt="Book a one-way outstation cab with Pulpit"
              className="main-bg-img"
              width="777"
              height="613"
              fetchpriority="high"
              decoding="async"
            />
            <div className="hero-icons-row">
              <div className="hero-icon-item">
                <img src={icon5} alt="10,000+ completed cab rides" className="hero-mini-icon" />
                <span className="hero-icon-label">10K+</span>
                <span className="hero-icon-sublabel">RIDES</span>
              </div>
              <div className="hero-icon-item">
                <img src={icon4} alt="Cab service in 450+ Indian cities" className="hero-mini-icon" />
                <span className="hero-icon-label">450+</span>
                <span className="hero-icon-sublabel">CITIES</span>
              </div>
              <div className="hero-icon-item">
                <img src={icon6} alt="4.9 out of 5 rider rating" className="hero-mini-icon" />
                <span className="hero-icon-label">4.9/5</span>
                <span className="hero-icon-sublabel">RATING</span>
              </div>
            </div>
          </div>

          {/* Form — order:-1 floats it above image on mobile */}
          <div className="home-hero-form-wrapper">
            <div className="home-hero-form">
              <Form routePrefill={routePrefill} />
            </div>
          </div>

        </div>
      </section>

      {/* The hero is an image and a booking form with no copy, so the homepage
          shipped without an <h1> at all. Sits below the fold-level hero so the
          booking form keeps its position. Cities reuse this component and supply
          their own <h1> in CityView, hence the prop rather than a hardcoded one. */}
      {heading && (
        <section className="home-main__intro">
          <h1 className="home-main__intro-title">{heading}</h1>
          {subheading && <p className="home-main__intro-text">{subheading}</p>}
        </section>
      )}

      <section className="home-main__features-wrapper">
        <h2 className="features-main-heading">Simple. Easy. Reliable.</h2>
        <div className="home-main__features">
          {featureData.map((item, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-card__image-wrapper">
                <img src={item.image} alt={item.alt} loading="lazy" decoding="async" />
                <div className="feature-card__title">{item.title}</div>
                <div className="feature-card__icon-box">
                  <img src={iconBg} alt="icon bg" className="feature-card__icon-bg" />
                  <img src={item.icon} alt="icon" className="feature-card__icon" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Main;